export const WITHDRAWAL_BALANCE_MAIN = 'withdrawal_balance_main';
export const CONFIRM_WITHDRAWAL_ACCCOUNT = 'confirm_withdrawal_account';
export const WITHDRAWAL_SUCCESS = 'withdrawal_success';

export const STEPS = [
    WITHDRAWAL_BALANCE_MAIN,
    CONFIRM_WITHDRAWAL_ACCCOUNT,
    WITHDRAWAL_SUCCESS,
];
